import { render, staticRenderFns } from "./SearchRes.vue?vue&type=template&id=747d7836&scoped=true"
import script from "./SearchRes.vue?vue&type=script&lang=js"
export * from "./SearchRes.vue?vue&type=script&lang=js"
import style0 from "./SearchRes.vue?vue&type=style&index=0&id=747d7836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d7836",
  null
  
)

export default component.exports